module.exports = __webpack_public_path__ + "media/Video 8b.985ad283.mp4";